export function generatePredictableConversationID(userID1: number, userID2: number): string {
  if (userID1 < userID2) {
    return `${userID1}-${userID2}`
  }

  return `${userID2}-${userID1}`
}

export function generateUserName(user: CanxUser): string {
  const firstName = user.firstName || ''
  const lastName = user.lastName || ''

  let displayedName = ''

  if (firstName) {
    displayedName += firstName
  }

  if (lastName) {
    displayedName += ' ' + lastName
  }

  if (user.company) {
    displayedName += ` (${user.company})`
  }

  return displayedName
}

export interface PublicConversationAPIResponse {
  pch_id: number
  pch_title: string
  pch_position: number
  pch_hash: string
  pch_description: string
  pch_date_created: string
  pch_date_updated: string
  pch_status: string
}

export interface ConversationMessageAPIResponse {
  attachment: { url: string, size: number } | null
  conversationId: string
  createdAt: number // Milliseconds since epoch
  custom: Record<string, string>
  id: string
  location: [number, number] | null
  origin: 'web' | 'rest' | 'email' | 'import'
  readBy: string[]
  senderId: string
  text: string
  type: 'UserMessage' | 'SystemMessage'
}

export interface PublicConversation {
  id: number
  subject: string
  position: number
  hash: string
  dateCreated: Date
  dateUpdated: Date
  status: string
  newMessagesAvailable: boolean
  lastMessage: ConversationMessage | null
}

export interface ConversationMessage {
  attachment: { url: string, size: number } | null
  conversationId: string
  createdAt: Date // Milliseconds since epoch
  custom: Record<string, string>
  id: string
  location: [number, number] | null
  origin: 'web' | 'rest' | 'email' | 'import'
  readBy: string[]
  senderId: string
  text: string
  type: 'UserMessage' | 'SystemMessage'
}

export interface PrivateConversationAPIResponse {
  createdAt: Date
  custom: unknown
  id: string
  isUnread: boolean
  lastMessage: ConversationMessageAPIResponse
  participants: Record<number, { access: string, notify: boolean }>
  photoUrl: string | null
  subject: string | null
  unreadMessageCount: number
}

export function toPublicConversation(conversation: PublicConversationAPIResponse, messages: ConversationMessage[] = []): PublicConversation {
  return {
    id: conversation.pch_id,
    subject: conversation.pch_title,
    position: conversation.pch_position,
    hash: conversation.pch_hash,
    dateCreated: new Date(conversation.pch_date_created),
    dateUpdated: new Date(conversation.pch_date_updated),
    status: conversation.pch_status,
    newMessagesAvailable: false, // messages.some(message => message.conversationId === conversation.pch_hash && message.createdAt > new Date(conversation.pch_date_updated).getTime()),
    lastMessage: messages.find(message => message.conversationId === conversation.pch_hash) || null,
  }
}

export function toConversationMessage(message: ConversationMessageAPIResponse): ConversationMessage {
  return {
    attachment: message.attachment,
    conversationId: message.conversationId,
    createdAt: new Date(message.createdAt),
    custom: message.custom,
    id: message.id,
    location: message.location,
    origin: message.origin,
    readBy: message.readBy,
    senderId: message.senderId,
    text: message.text,
    type: message.type,
  }
}
